module.exports = __webpack_public_path__ + "static/img/demand-widget-1.b98d6511.png";